import React from 'react';
import styled from 'styled-components';
import MapImg from '../assets/images/map.png';
import PText from './PText';

const MapStyles = styled.div`
  background: url(${MapImg}) no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 400px;
  .container {
    position: relative;
    min-height: 400px;
  }
  .map__card {
    position: absolute;
    right: 10%;
    bottom: 10%;
    padding: 2rem;
    background: var(--deep-dark);
    width: 100%;
    max-width: 300px;
    border-radius: 12px;
  }
  .map__card__heading {
    font-size: 3rem;
    margin-bottom: 1rem;
  }
  .map__card__link {
    display: inline-block;
    font-size: 1.6rem;
    margin-top: 3rem;
    text-decoration: underline;
  }
  @media only screen and (max-width: 768px) {
    background-position: 80% center;
  }
  @media only screen and (max-width: 400px) {
    .map__card {
      max-width: none;
      right: auto;
    }
  }
`;

export default function Map() {
  return (
    <MapStyles>
      <div className="container">
        <div className="map__card">
          <h3 className="map__card__heading">Here is me</h3>
          <PText>Near Quest Mall, Kolkata</PText>
          <a
            className="map__card__link"
            href="https://www.google.com/maps/place/Quest+Mall/@22.5389519,88.3635651,17z/data=!3m1!5s0x3a0276de3a0370ad:0xbd3e6abebde73b82!4m12!1m6!3m5!1s0x3a0276dfad4bf901:0xfbbe370e3a5a4dc8!2sQuest+Mall!8m2!3d22.5393357!4d88.3655843!3m4!1s0x3a0276dfad4bf901:0xfbbe370e3a5a4dc8!8m2!3d22.5393357!4d88.3655843"
            target="_blank"
            rel="noreferrer"
          >
            Open in google map
          </a>
        </div>
      </div>
      {/* <img src={MapImg} alt="Map" /> */}
    </MapStyles>
  );
}
